// extracted by mini-css-extract-plugin
module.exports = {"transition":"ViewportPainter_transition__JXl0F"};